import { useTranslation } from 'react-i18next';

import organizationConfig from '../pages/Organization/menuConfig';
import salesConfig from '../pages/Sales/menuConfig';
import operationsConfig from '../pages/Operations/menuConfig';
import cashConfig from '../pages/CashOffice/menuConfig';
import brandingConfig from '../pages/Branding/menuConfig';

import { IGenericObject } from 'types';
import { IMenuSearchItem } from './types';

const useMenuItems = () => {
  const { t } = useTranslation();

  const getItemTitle = (name: string) => {
    const titleFromBreadCrumb = t(`label.${name}`, { returnObjects: true });

    return titleFromBreadCrumb && typeof titleFromBreadCrumb === 'string'
      ? titleFromBreadCrumb
      : name;
  };

  const convertMenu = (config: IGenericObject[], path, name) => {
    const level1Title = getItemTitle(name);
    const items: IMenuSearchItem[] = [
      {
        path,
        title: level1Title,
      },
    ];

    config.forEach(({ options, path: level2Path, name }) => {
      const level2AbsolutePath = `${path}${level2Path}`;
      const level2Title = getItemTitle(name);

      items.push({ path: level2AbsolutePath, title: level2Title, parents: [level1Title] });

      if (Array.isArray(options)) {
        options.forEach(({ path: level3Path, name }) => {
          const level3AbsolutePath = `${path}${level2Path}${level3Path}`;
          const level3Title = getItemTitle(name);

          items.push({
            path: level3AbsolutePath,
            title: level3Title,
            parents: [level1Title, level2Title],
          });
        });
      }
    });

    return items;
  };

  return [
    ...convertMenu(organizationConfig, '/organization', 'organization'),
    ...convertMenu(salesConfig, '/sales', 'sales'),
    ...convertMenu(operationsConfig, '/operations', 'operations'),
    ...convertMenu(cashConfig, '/cash-office', 'cashOffice'),
    ...convertMenu(brandingConfig, '/branding', 'branding'),
  ];
};

export default useMenuItems;
